module.exports = __webpack_public_path__ + "static/nervometal-9296d7c2706e5e6cba6e035583e3b4d6.jpg";